<style lang="scss">
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/mixins";

  .sourced-via-tag {
    @include colors.color(textGrey);
    @include mixins.body3();

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: utils.in_rem(4px);

    padding-bottom: utils.in_rem(4px);
    word-break: break-word;
    overflow-wrap: break-word;
  }
</style>

<script>
  import { CRMS } from "../../../../src/assets/js/src/general/utils";
  import Icon from "../Icon.svelte";
  import Tooltip from "../Tooltip.svelte";

  const iconMapping = {
    LinkedIn: "fab fa-linkedin",
    Spreadsheet: "far fa-file-spreadsheet",
    CRM: "far fa-database",
    Resume: "far fa-file-user",
  };

  const crmTitles = [
    ...Object.values(CRMS),
    "Avionte",
    "EBoss",
    "ICIMS",
    "Jazz HR",
    "Mercury",
    "Worksuite",
  ];

  export let source = "";
  export let sourceName = "";

  let label = "";
  let icon = "";

  $: labelSource = sourceName || source;
  $: tooltipSource = source === "addedManually" ? "" : source;

  $: if (labelSource) {
    label =
      labelSource === "Added Manually"
        ? labelSource
        : `Sourced via ${labelSource}`;
    icon = crmTitles.includes(source)
      ? iconMapping.CRM
      : iconMapping[labelSource];
  }
</script>

{#if tooltipSource && !icon}
  <div class="sourced-via-tag">
    <Tooltip
      placement="top"
      let:onmouseenter
      let:onmouseleave
      let:onblur
      let:onfocus
    >
      <span slot="tooltip">{tooltipSource}</span>
      <span
        {onmouseenter}
        {onmouseleave}
        {onfocus}
        {onblur}
        role="button"
        tabindex="-1"
      >
        {label}
      </span>
    </Tooltip>
  </div>
{:else if tooltipSource && icon}
  <div class="sourced-via-tag">
    {label}
    <Icon class={icon} placement="top">
      <span slot="tooltip">{tooltipSource}</span>
    </Icon>
  </div>
{:else}
  <div class="sourced-via-tag">
    {label}
    {#if icon}
      <Icon class={icon} />
    {/if}
  </div>
{/if}
